<mat-icon *ngIf="id !== undefined" class="share" (click)="clickPartage()">share</mat-icon>
<button *ngIf="id === undefined" type="button" (click)="clickPartage()" class="ml-3 btn btn-outline-primary" id="shareButton">
  <span *ngIf="!isAcheteur">
    {{ preferenceMessages.modal_partage_button_label | translate }}
  </span>
  <span *ngIf="isAcheteur">
    {{ preferenceMessages.modal_partage_button_label_acheteur | translate }}
  </span>
  <mat-icon class="ml-1">share</mat-icon>
</button>
